import React from 'react';
import packageJson from '../../package.json';
global.appVersion = packageJson.version;

const clearCache = () => {
  // deleta cache e recarrega página
  window.location.reload(true);
}

class CacheBuster extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      isLatestVersion: false,
      serverVersion: '',
      clientVersion: '',
      checkReloading: () => {
        fetch('/meta.json')
          .then((response) => response.json())
          .then((meta) => {
            const latestVersion = meta.version;
            const currentVersion = global.appVersion;
            
            this.serverVersion =  meta.version;
            this.clientVersion = global.appVersion;

            //alert(`meta.version => v ${meta.version} - global.appVersion => v ${global.appVersion}`);
            // console.log(`server version => v ${meta.version} - client appVersion => v ${global.appVersion}`)
            if (meta.version != global.appVersion) {
              clearCache();    
            }
          });
      }
    };
  }

  render() {
    const { loading, isLatestVersion, serverVersion, clientVersion, checkReloading } = this.state;
    return this.props.children({ loading, isLatestVersion, serverVersion, clientVersion, checkReloading });
  }
}

export default CacheBuster;